jQuery( document ).ready( function() {
	let category;
	let idsArray;

	jQuery( '.category.button' ).click( function() {
		jQuery( '.category.button' ).removeClass( 'active-category' );
		jQuery( this ).addClass( 'active-category' );
		category = jQuery( this ).data( 'slug' );
		// console.log( category );
		idsArray = [];
		jQuery( '.ajax-selected-id' ).each( function() {
			const id = jQuery( this ).data( 'id' ); // Get the value of 'data-id' attribute
			idsArray.push( id ); // Add the ID to the array
			// console.log( idsArray );
		} );
		sendAjaxRequest();
	} );

	function reInitTestimonialblock() {
		const sliderContainer = jQuery( '.theme-quotes-category' );

		if ( sliderContainer.length == 1 ) {
			sliderContainer.slick( {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: true,
				autoplay: true,
				autoplaySpeed: 8000,
				infinite: false,
			} );

			const total = ( '0' + sliderContainer.slick( 'getSlick' ).slideCount ).slice( -2 );
			jQuery( '.wide-slide-count .wide-total-slides' ).text( total );

			sliderContainer.on( 'afterChange', function( event, slick, currentSlide ) {
				const current = ( '0' + ( currentSlide + 1 ) ).slice( -2 );
				jQuery( '.wide-slide-count .wide-current-slide' ).text( current );
			} );

			const current = ( '0' + 1 ).slice( -2 );
			jQuery( '.wide-slide-count .wide-current-slide' ).text( current );
		}
	}

	reInitTestimonialblock();

	function sendAjaxRequest() {
		jQuery( '.theme-quote-loader-container' ).show();

		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'POST', // Use 'GET' or 'POST' as needed
			data: {
				action: 'ajax_testimonial',
				category,
				idsArray,
			}, // Pass the data to the server
			success( response ) {
				console.log( response );
				idsArray = [];

				console.log( 'AFTER AJAX', jQuery( '.theme-quotes' ).length );
				console.log( 'Is slick?', jQuery( '.theme-quotes' ).hasClass( 'slick-initialized' ) );

				// Handle the server's response here
				jQuery( '.theme-quotes-category' ).slick( 'unslick' );
				jQuery( '#ajax-testimonial-container' ).empty();
				jQuery( '#ajax-testimonial-container' ).html( response.html );
				reInitTestimonialblock();
				setTimeout( () => {
					if ( jQuery( '.theme-quote-wide' ).length > 0 ) {
						jQuery( '.theme-quote-wide .slick-prev' ).append( `
		            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
		                <path d="M0.346874 9.81538C0.126562 9.60444 0 9.30912 0 8.99975C0 8.69038 0.126562 8.39975 0.346874 8.18413L8.59687 0.309126C9.04687 -0.122124 9.75938 -0.103374 10.1859 0.346626C10.6125 0.796626 10.5984 1.50913 10.1484 1.93569L3.93281 7.87475H18.875C19.4984 7.87475 20 8.37631 20 8.99975C20 9.62319 19.4984 10.1248 18.875 10.1248H3.93281L10.1531 16.0591C10.6031 16.4904 10.6172 17.1982 10.1906 17.6482C9.76406 18.0982 9.05156 18.1123 8.60156 17.6857L0.351562 9.81069L0.346874 9.81538Z" fill="#243B4A"/>
		            </svg>
		        ` );

						jQuery( '.theme-quote-wide .slick-next' ).append( `
		            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
		                <path d="M19.6531 9.81538C19.8734 9.60444 20 9.30912 20 8.99975C20 8.69038 19.8734 8.39975 19.6531 8.18413L11.4031 0.309126C10.9531 -0.122124 10.2406 -0.103374 9.81406 0.346626C9.3875 0.796626 9.40156 1.50913 9.85156 1.93569L16.0672 7.87475H1.125C0.501562 7.87475 0 8.37631 0 8.99975C0 9.62319 0.501562 10.1248 1.125 10.1248H16.0672L9.84687 16.0591C9.39687 16.4904 9.38281 17.1982 9.80938 17.6482C10.2359 18.0982 10.9484 18.1123 11.3984 17.6857L19.6484 9.81069L19.6531 9.81538Z" fill="#243B4A"/>
		            </svg>
		        ` );
					}
				}, 400 );
				jQuery( '.theme-quote-loader-container' ).hide();
			},
			error( xhr, status, error ) {
				jQuery( '.theme-quote-loader-container' ).hide();
				error_html = `<h2 class="heading-4 center-align">${ error }</h2>`;
				jQuery( '#ajax-testimonial-container' ).html( error_html );
			},
		} );
	}
} );

